export function clamp(n: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, n));
}

export function syncFocusFromPlayhead(playheadMs: number): {
  focusedTimestamp: number;
  focusedTimeRange: [number, number];
} {
  const half = 220;
  return {
    focusedTimestamp: playheadMs,
    focusedTimeRange: [playheadMs - half, playheadMs + half],
  };
}
